export default __webpack_public_path__ + "static/media/table.463366bc.jpg";